// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.addp-dashboard-page h1 {
  margin-top: 30px;
}
.addp-dashboard-page .initial-text,
.addp-dashboard-page h4 {
  font-size: 1.8rem;
}
.addp-dashboard-page .alert {
  margin-bottom: 20px;
}
.addp-dashboard-page .addp-dashboard-container {
  margin-bottom: 30px;
}
.addp-dashboard-page .addp-dashboard-container.height-set .dashboard-button-container {
  bottom: 0;
  position: absolute;
  width: 100%;
}
.addp-dashboard-page .addp-dashboard-container.height-set .col-md-size,
.addp-dashboard-page .addp-dashboard-container.height-set .container,
.addp-dashboard-page .addp-dashboard-container.height-set .inside-container {
  height: 100%;
}
.addp-dashboard-page .addp-dashboard-container .container {
  border-radius: 10px;
  border-radius: 10px;
  border-radius: 10px;
  border-radius: 10px;
  border-radius: 10px;
  border: 1px solid #d2d2d2;
  margin: 0 auto;
  padding: 20px;
}
.addp-dashboard-page .addp-dashboard-container .inside-container {
  position: relative;
}
.addp-dashboard-page .addp-dashboard-container .dashboard-error-box {
  margin-bottom: 20px;
}
.addp-dashboard-page .addp-dashboard-container .dashboard-button-container {
  border-top: 1px solid #d2d2d2;
  padding-top: 15px;
  position: relative;
  bottom: 0;
}
.addp-dashboard-page .addp-dashboard-container .dashboard-button-container button {
  margin: 0;
  width: 100%;
}
.addp-dashboard-page .addp-dashboard-container .donut-chart-container {
  margin: 20px 20px 20px 0;
}
.addp-dashboard-page .addp-dashboard-container .donut-chart-legend-container {
  margin-bottom: 20px;
}
.addp-dashboard-page .addp-dashboard-container .apple-cert {
  margin-bottom: 20px;
  margin-top: 20px;
}
.addp-dashboard-page .addp-dashboard-container .apple-cert div {
  position: relative;
}
.addp-dashboard-page .addp-dashboard-container .remove-account {
  margin-bottom: 20px;
}
.addp-dashboard-page .addp-dashboard-container .ico {
  color: #ff9a38;
  font-size: 30px;
}
.addp-dashboard-page .addp-dashboard-container .flex-container {
  flex-direction: row;
  flex-direction: row;
  flex-direction: row;
  flex-direction: row;
  flex-direction: row;
  align-items: center;
  align-items: center;
  align-items: center;
  align-items: center;
  align-items: center;
  display: flex;
}
.addp-dashboard-page .addp-dashboard-container .show-mobile {
  display: none;
}
.addp-dashboard-page .addp-dashboard-container .show-desktop {
  display: inline-block;
}
@media (max-width: 1024px) {
  .addp-dashboard-page .addp-dashboard-container.height-set .dashboard-button-container {
    bottom: 0;
    position: absolute;
    width: 100%;
  }
  .addp-dashboard-page .addp-dashboard-container.height-set .col-md-size,
  .addp-dashboard-page .addp-dashboard-container.height-set .container,
  .addp-dashboard-page .addp-dashboard-container.height-set .inside-container {
    height: auto;
  }
  .addp-dashboard-page .addp-dashboard-container .initial-text {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
  }
  .addp-dashboard-page .addp-dashboard-container .col-md-size {
    padding: 10px 15px;
  }
  .addp-dashboard-page .addp-dashboard-container .device-hide,
  .addp-dashboard-page .addp-dashboard-container .show-desktop {
    display: none;
  }
  .addp-dashboard-page .addp-dashboard-container .show-mobile {
    display: inline-block;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AA3IE;EACE,gBAAA;AA6IJ;AA1IE;;EAEE,iBAAA;AA4IJ;AAzIE;EACE,mBAAA;AA2IJ;AAxIE;EACE,mBAAA;AA0IJ;AAvIM;EACE,SAAA;EACA,kBAAA;EACA,WAAA;AAyIR;AAtIM;;;EAGE,YAAA;AAwIR;AApII;EFFA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EEIE,yBAAA;EACA,cAAA;EACA,aAAA;AA0IN;AAvII;EACE,kBAAA;AAyIN;AAtII;EACE,mBAAA;AAwIN;AArII;EACE,6BAAA;EAEA,iBAAA;EACA,kBAAA;EACA,SAAA;AAsIN;AApIM;EACE,SAAA;EACA,WAAA;AAsIR;AAlII;EACE,wBAAA;AAoIN;AAjII;EACE,mBAAA;AAmIN;AAhII;EACE,mBAAA;EACA,gBAAA;AAkIN;AAhIM;EACE,kBAAA;AAkIR;AA9HI;EACE,mBAAA;AAgIN;AA7HI;EACE,cAAA;EACA,eAAA;AA+HN;AA5HI;EFxDA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EE4DE,aAAA;AAsIN;AAnII;EACE,aAAA;AAqIN;AAlII;EACE,qBAAA;AAoIN;AFpNI;EEsFI;IACE,SAAA;IACA,kBAAA;IACA,WAAA;EAiIR;EA9HM;;;IAGE,YAAA;EAgIR;EA5HI;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EA8HN;EA3HI;IACE,kBAAA;EA6HN;EA1HI;;IAEE,aAAA;EA4HN;EAzHI;IACE,qBAAA;EA2HN;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n// @media screen and (max-width: 1025px) and (min-width: 300px)  {\n//   .addp-dashboard-page {\n//     margin-left: 0px;\n// }}\n\n.addp-dashboard-page {\n  h1 {\n    margin-top: 30px;\n  }\n\n  .initial-text,\n  h4 {\n    font-size: 1.8rem;\n  }\n\n  .alert {\n    margin-bottom: 20px;\n  }\n\n  .addp-dashboard-container {\n    margin-bottom: 30px;\n\n    &.height-set {\n      .dashboard-button-container {\n        bottom: 0;\n        position: absolute;\n        width: 100%;\n      }\n\n      .col-md-size,\n      .container,\n      .inside-container {\n        height: 100%;\n      }\n    }\n\n    .container {\n      @include vendor-prefix('border-radius', 10px);\n      border: 1px solid color(default, dark);\n      margin: 0 auto;\n      padding: 20px;\n    }\n\n    .inside-container {\n      position: relative;\n    }\n\n    .dashboard-error-box {\n      margin-bottom: 20px;\n    }\n\n    .dashboard-button-container {\n      border-top: 1px solid color(default, dark);\n\n      padding-top: 15px;\n      position: relative;\n      bottom: 0;\n\n      button {\n        margin: 0;\n        width: 100%;\n      }\n    }\n\n    .donut-chart-container {\n      margin: 20px 20px 20px 0;\n    }\n\n    .donut-chart-legend-container {\n      margin-bottom: 20px;\n    }\n\n    .apple-cert {\n      margin-bottom: 20px;\n      margin-top: 20px;\n\n      div {\n        position: relative;\n      }\n    }\n\n    .remove-account {\n      margin-bottom: 20px;\n    }\n\n    .ico {\n      color: color(primary, light);\n      font-size: 30px;\n    }\n\n    .flex-container {\n      @include vendor-prefix('flex-direction', row);\n      @include vendor-prefix('align-items', center);\n      display: -webkit-flex;\n      display: flex;\n    }\n\n    .show-mobile {\n      display: none;\n    }\n\n    .show-desktop {\n      display: inline-block;\n    }\n\n    @include respond-to (small) {\n\n      &.height-set {\n        .dashboard-button-container {\n          bottom: 0;\n          position: absolute;\n          width: 100%;\n        }\n\n        .col-md-size,\n        .container,\n        .inside-container {\n          height: auto;\n        }\n     }\n\n      .initial-text {\n        font-size: 14px;\n        font-weight: bold;\n        margin-bottom: 0;\n      }\n\n      .col-md-size {\n        padding: 10px 15px;\n      }\n\n      .device-hide,\n      .show-desktop {\n        display: none;\n      }\n\n      .show-mobile {\n        display: inline-block;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
